/* eslint-disable */

import { NavLink, useLocation } from 'react-router-dom';
// chakra imports
import {
  Box,
  Flex,
  HStack,
  Text,
  List,
  Icon,
  ListItem,
  useColorModeValue,
} from '@chakra-ui/react';
// Assets
import { FaCircle } from 'react-icons/fa';
import {
  MdAddCircleOutline,
  MdAdminPanelSettings,
  MdCalendarMonth,
  MdDashboard,
  MdHowToVote,
  MdLock,
  MdManageAccounts,
  MdOutlineListAlt,
  MdOutlinePoll,
  MdPeople,
  MdPerson,
  MdPersonAdd,
  MdPhotoLibrary,
  MdSettings,
  MdShoppingCart,
  MdStorefront,
  MdThumbDown,
  MdThumbUp,
} from 'react-icons/md';

export function SidebarLinks(props: {
  routes: RoutesType[];
  [x: string]: any;
}) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue('gray.700', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  let activeIcon = useColorModeValue('brand.500', 'white');
  let activeSubsectionBg = useColorModeValue('brand.50', 'whiteAlpha.100');
  let activeSubsectionBorder = useColorModeValue('brand.200', 'whiteAlpha.300');
  let hoverSubsectionBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.50');
  let groupLabelColor = useColorModeValue('secondaryGray.700', 'secondaryGray.300');

  const { routes, hovered, mini, onNavigate } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const isExactRouteActive = (route: RoutesType) => {
    const fullPath = `${route.layout || ''}${route.path || ''}`;
    return (
      location.pathname === fullPath ||
      location.pathname.startsWith(`${fullPath}/`)
    );
  };

  const normalizeRouteName = (value: string) =>
    value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const getSectionIcon = (routeName: string) => {
    const normalizedName = normalizeRouteName(routeName);

    if (normalizedName.includes('dashboard') || normalizedName.includes('centro de datos')) {
      return MdDashboard;
    }
    if (normalizedName.includes('votante')) {
      return normalizedName.includes('nuevo') ? MdPersonAdd : MdHowToVote;
    }
    if (normalizedName.includes('candidato')) {
      return normalizedName.includes('nuevo') ? MdPersonAdd : MdPerson;
    }
    if (normalizedName.includes('encuesta')) {
      return normalizedName.includes('nueva') ? MdAddCircleOutline : MdOutlinePoll;
    }
    if (normalizedName.includes('supervisor')) {
      return normalizedName.includes('nuevo') ? MdPersonAdd : MdManageAccounts;
    }
    if (normalizedName.includes('admin')) {
      return normalizedName.includes('nuevo') ? MdPersonAdd : MdAdminPanelSettings;
    }
    if (normalizedName.includes('personal')) {
      return normalizedName.includes('nuevo') ? MdPersonAdd : MdPeople;
    }
    if (normalizedName.includes('proveedor')) {
      return normalizedName.includes('nuevo') ? MdAddCircleOutline : MdStorefront;
    }
    if (normalizedName.includes('compra')) {
      return normalizedName.includes('nueva') ? MdAddCircleOutline : MdShoppingCart;
    }
    if (normalizedName.includes('actividad') || normalizedName.includes('agenda')) {
      return normalizedName.includes('nueva') ? MdAddCircleOutline : MdCalendarMonth;
    }
    if (normalizedName.includes('galeria') || normalizedName.includes('evidencia')) {
      return MdPhotoLibrary;
    }
    if (normalizedName.includes('configuracion')) {
      return MdSettings;
    }
    if (normalizedName.includes('carga inicial')) {
      return MdOutlineListAlt;
    }
    if (normalizedName.includes('ajuste positivo')) {
      return MdThumbUp;
    }
    if (normalizedName.includes('ajuste negativo')) {
      return MdThumbDown;
    }
    if (normalizedName.includes('auth') || normalizedName.includes('sesion')) {
      return MdLock;
    }

    return FaCircle;
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route, key) => {
      if ((route as any).hidden) return null;
      if (route.collapse) {
        const isGroupActive = activeRoute(route.path.toLowerCase());
        return (
          <Box key={key} w="100%" mb="10px">
            <Flex
              align="center"
              w="100%"
              px={route.icon ? '17px' : '34px'}
              mb="6px"
              minH="34px"
            >
              {route.icon ? (
                <>
                  <Box
                    color={isGroupActive ? activeIcon : inactiveColor}
                    me={
                      mini === false
                        ? '12px'
                        : mini === true && hovered === true
                        ? '12px'
                        : '0px'
                    }
                    mt="2px"
                  >
                    {route.icon}
                  </Box>
                  <Text
                    display={
                      mini === false
                        ? 'block'
                        : mini === true && hovered === true
                        ? 'block'
                        : 'none'
                    }
                    color={isGroupActive ? activeColor : groupLabelColor}
                    fontWeight={isGroupActive ? '700' : '600'}
                    fontSize="md"
                  >
                    {route.name}
                  </Text>
                </>
              ) : (
                <Text
                  display={
                    mini === false
                      ? 'block'
                      : mini === true && hovered === true
                      ? 'block'
                      : 'none'
                  }
                  color={isGroupActive ? activeColor : groupLabelColor}
                  fontWeight={isGroupActive ? '700' : '600'}
                  fontSize="sm"
                >
                  {route.name}
                </Text>
              )}
            </Flex>
            <Box
              display={
                mini === false
                  ? 'block'
                  : mini === true && hovered === true
                  ? 'block'
                  : 'flex'
              }
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              pe={route.icon ? '14px !important' : '0px'}
              py="0px"
              ps={route.icon ? '14px !important' : '8px'}
            >
              <List>
                {route.icon ? createLinks(route.items) : createAccordionLinks(route.items)}
              </List>
            </Box>
          </Box>
        );
      } else {
        const isActive = route.icon
          ? activeRoute(route.path.toLowerCase())
          : isExactRouteActive(route);
        const subsectionIcon = getSectionIcon(route.name);
        return (
          <NavLink to={route.layout + route.path} key={key} onClick={onNavigate}>
            {route.icon ? (
              <Flex
                align="center"
                justifyContent="space-between"
                w="100%"
                ps="17px"
                mb="0px"
              >
                <HStack
                  mb="6px"
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? '22px' : '26px'
                  }
                >
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : inactiveColor
                      }
                      me="12px"
                      mt="6px"
                    >
                      {route.icon}
                    </Box>
                    <Text
                      me="auto"
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : 'secondaryGray.600'
                      }
                      fontWeight="500"
                    >
                      {mini === false
                        ? route.name
                        : mini === true && hovered === true
                        ? route.name
                        : route.name[0]}
                    </Text>
                  </Flex>
                </HStack>
              </Flex>
            ) : (
              <ListItem ms={null}>
                <Flex
                  borderRadius="14px"
                  px={mini === false || (mini === true && hovered === true) ? '14px' : '0px'}
                  py="10px"
                  ps={
                    mini === false
                      ? '18px'
                      : mini === true && hovered === true
                      ? '18px'
                      : '0px'
                  }
                  alignItems="center"
                  mb="8px"
                  gap="12px"
                  bg={isActive ? activeSubsectionBg : 'transparent'}
                  borderWidth="1px"
                  borderColor={isActive ? activeSubsectionBorder : 'transparent'}
                  _hover={{
                    bg: isActive ? activeSubsectionBg : hoverSubsectionBg,
                  }}
                >
                  <Icon
                    as={subsectionIcon}
                    boxSize="18px"
                    color={isActive ? activeIcon : inactiveColor}
                    flexShrink={0}
                  />
                  <Text
                    display={
                      mini === false
                        ? 'block'
                        : mini === true && hovered === true
                        ? 'block'
                        : 'none'
                    }
                    color={
                      isActive ? activeColor : inactiveColor
                    }
                    fontWeight={isActive ? '700' : '500'}
                    fontSize="sm"
                  >
                    {route.name}
                  </Text>
                </Flex>
              </ListItem>
            )}
          </NavLink>
        );
      }
    });
  };
  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createAccordionLinks = (routes: RoutesType[]) => {
    return routes.map((route: RoutesType, key: number) => {
      if ((route as any).hidden) return null;
      const isActive = isExactRouteActive(route);
      const subsectionIcon = getSectionIcon(route.name);
      return (
        <NavLink to={route.layout + route.path} key={key} onClick={onNavigate}>
          <ListItem
            ms={
              mini === false
                ? '14px'
                : mini === true && hovered === true
                ? '14px'
                : '0px'
            }
            display="flex"
            alignItems="center"
            mb="10px"
            key={key}
            borderRadius="14px"
            px={mini === false || (mini === true && hovered === true) ? '14px' : '0px'}
            py="10px"
            gap="10px"
            bg={isActive ? activeSubsectionBg : 'transparent'}
            borderWidth="1px"
            borderColor={isActive ? activeSubsectionBorder : 'transparent'}
            _hover={{
              bg: isActive ? activeSubsectionBg : hoverSubsectionBg,
            }}
          >
            <Icon
              w="16px"
              h="16px"
              as={subsectionIcon}
              color={isActive ? activeIcon : inactiveColor}
              flexShrink={0}
            />
            <Text
              display={
                mini === false
                  ? 'block'
                  : mini === true && hovered === true
                  ? 'block'
                  : 'none'
              }
              color={
                isActive ? activeColor : inactiveColor
              }
              fontWeight={isActive ? '700' : '500'}
              fontSize="sm"
            >
              {route.name}
            </Text>
          </ListItem>
        </NavLink>
      );
    });
  };
  //  BRAND
  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
